import { Route } from '@angular/router'
import { SandboxComponent, VenueListComponent } from '@monorepo-channels/components/feature-porto-bank'
import { VenueDetailsPageComponent } from './pages/venues-list/venue-details/venue-details.page'
import { CheckinPageComponent } from './pages/checkin/checkin.page'
import { OrdersHistoryPageComponent } from './pages/order-history/order-history.page'
import { OrdersDetailsPageComponent } from './pages/order-history/order-details.page'
import { authGuard } from '@monorepo-channels/channels/domain'
import { ProfilePageComponent } from './pages/profile/profile.page'
import { ReservationPageComponent } from './pages/reservation/reservation.page'
import { FAQPageComponent } from './pages/faq/faq.page'
import { HowItWorksPageComponent } from './pages/how-it-works/how-it-works.page'
import { TermsOfUsePageComponent } from './pages/terms-and-conditions/terms-and-conditions.component'
import { PrivacyPolicyPageComponent } from './pages/privacy-policy/privacy-policy.page'

export const appRoutes: Route[] = [
	{
		path: '',
		component: VenueListComponent,
	},
	{
		path: 'cadastro',
		loadComponent: () => import('./pages/sign-up/sign-up.page').then(m => m.SignUpPageComponent),
	},
	{
		path: 'entrar',
		loadComponent: () => import('./pages/sign-up/sign-up.page').then(m => m.SignUpPageComponent),
	},
	{
		path: 'perfil',
		component: ProfilePageComponent,
		title: 'Gastronomia Porto Bank - Meus dados',
		canActivate: [authGuard],
	},
	{
		path: 'restaurante/:venueId',
		component: VenueDetailsPageComponent,
		title: 'Gastronomia Porto Bank - Restaurante',
	},
	{
		path: 'restaurante/:venueId/checkin',
		component: CheckinPageComponent,
		title: 'Gastronomia Porto Bank - Check-in',
		canActivate: [authGuard],
	},
	{
		path: 'restaurante/:venueId/reserva',
		component: ReservationPageComponent,
		title: 'Gastronomia Porto Bank - Reserva',
		canActivate: [authGuard],
	},
	{
		path: 'reservas-e-checkins',
		component: OrdersHistoryPageComponent,
		title: 'Gastronomia Porto Bank - Reservas e Check-ins',
		canActivate: [authGuard],
	},
	{
		path: 'reservas-e-checkins/pedido/:orderId',
		title: 'Gastronomia Porto Bank - Detalhes do Pedido',
		component: OrdersDetailsPageComponent,
		canActivate: [authGuard],
	},
	{
		path: 'como-funciona',
		title: 'Gastronomia Porto Bank - Como Funciona',
		component: HowItWorksPageComponent,
	},
	{
		path: 'politica-de-privacidade',
		title: 'Gastronomia Porto Bank - Política de Privacidade',
		component: PrivacyPolicyPageComponent,
	},
	{
		path: 'termos-de-uso',
		title: 'Gastronomia Porto Bank - Termos de uso',
		component: TermsOfUsePageComponent,
	},
	{
		path: 'faq',
		title: 'Gastronomia Porto Bank - FAQ',
		component: FAQPageComponent,
	},
	{
		path: 'sandbox',
		component: SandboxComponent,
	},
]
